import { createFileRoute } from '@tanstack/react-router';
import FormSettings from '@/features/agent/form/components/FormSettings';
import useFetchCandidateForm from '@/features/agent/form/api/useFetchCandidateForm';
import Loading from '@/components/Loading';

export const Route = createFileRoute('/agent/form/settings')({
  component: FormSettingsPage,
  staticData: { title: 'フォーム設定' },
});

function FormSettingsPage() {
  const { data: candidateForm, isLoading, error } = useFetchCandidateForm();

  // ローディング中
  if (isLoading) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] items-center justify-center">
        <Loading />
      </div>
    );
  }

  // エラーが発生した場合
  if (error || !candidateForm) {
    return (
      <div className="flex min-h-[calc(100vh-120px)] items-center justify-center">
        <div className="text-center">
          <p className="text-lg font-bold text-main">エラーが発生しました</p>
          <p className="mt-2 text-sm text-gray">
            フォームの読み込みに失敗しました。ページをリロードしてください。
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-3">
      <FormSettings candidateForm={candidateForm} />
    </div>
  );
}
